/* Two bands, as d360: a header that names the number and its scope, and a
   darker body that carries the figure. */
.widget {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  /* No overflow:hidden — the trend tooltip rises over the header. The body
     carries its own bottom radius instead. */
}

.header {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
}

.heading {
  flex: 1;
  min-width: 0;
}

.title {
  margin: 0;
  font-size: var(--text-md);
  font-weight: var(--weight-semi);
  color: var(--text-primary);
  line-height: 1.3;
}

.scope {
  margin: 2px 0 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hint {
  flex-shrink: 0;
  margin-top: 3px;
  color: var(--text-disabled);
  cursor: help;
  transition: color var(--duration-fast) var(--ease-default);
}

.hint:hover {
  color: var(--text-secondary);
}

.body {
  flex: 1;
  display: flex;
  align-items: center;
  gap: var(--space-4);
  min-height: 84px;
  padding: var(--space-3) var(--space-4);
  background: var(--bg-base);
  border-top: 1px solid var(--border-subtle);
  border-radius: 0 0 calc(var(--radius-lg) - 1px) calc(var(--radius-lg) - 1px);
}

.figure {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  flex-shrink: 0;
}

/* Muted unit so the eye lands on the number */
.unit {
  font-family: var(--font-display);
  font-size: 34px;
  line-height: 1;
  color: var(--text-muted);
}

.unitIcon {
  color: var(--text-muted);
  fill: currentColor;
}

.value {
  font-family: var(--font-display);
  font-size: 44px;
  line-height: 1;
  letter-spacing: 0.02em;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

/* d360's rank: big number, muted "#", movement underneath */
.rank {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
}

.rankValue {
  font-family: var(--font-display);
  font-size: 28px;
  line-height: 1;
  letter-spacing: 0.02em;
  color: var(--text-primary);
}

.rankPound {
  color: var(--text-muted);
}

.rankChange {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: var(--text-xs);
  font-weight: var(--weight-semi);
  font-variant-numeric: tabular-nums;
  color: var(--text-muted);
}

.rankChange[data-dir='up'] {
  color: var(--color-success);
}

.rankChange[data-dir='down'] {
  color: var(--color-danger);
}

.rankArrow {
  fill: currentColor;
}

.rankChange[data-dir='down'] .rankArrow {
  rotate: 180deg;
}

.aside {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

/* Takes whatever room the figure and rank leave, so it never spills out */
.trend {
  flex: 1 1 0;
  min-width: 56px;
  max-width: 180px;
  margin-left: auto;
}

@media (max-width: 640px) {
  .trend {
    display: none;
  }
}
